<template>
 <transition name="fade">
  <div class="modaloutside" v-if="isShow">
    <div class="modalcontent">
      <div class="headeroutside">
        <div class="header">{{title}}</div>
      </div>
      <div class="footer">
        <div class="cancel" @click="cancel">{{ cancelBtn }}</div>
        <div class="close" @click="onOk">{{okBtn}}</div>
      </div>
    </div>
  </div>
  </transition>
</template>
<script>
export default {
  name: "uploadModal",
  props: {
    isShow: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    title:{
      type: String,
      default:()=>{
        return '提示'
      }
    },
    content:{
      type: String,
      default:()=>{
        return '你已添加5项附件，是否确定上传'
      }
    },
    okBtn:{
      type: String,
      default:()=>{
        return '确定'
      }
    },
    cancelBtn:{
      type: String,
      default:()=>{
        return '取消'
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    onOk(){
        this.$emit('onOk');
    }
  }
};
</script>
<style lang="less" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
.modaloutside {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 9999;
  .modalcontent {
    width: 260px;
    height: 172px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    position: relative;
    overflow: hidden;
  }
  .headeroutside {
    width: 100%;
    height: 18px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 53px;
  }
  .contentoutside {
    width: 100%;
    height: 42px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 12px;
  }
  .header {
    width: 196px;
    height: 18px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    text-align: center;
  }
  .content {
    width: 196px;
    height: 44px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    line-height: 22px;
    text-align: center;
  }
  .footer {
    width: 100%;
    height: 47px;
    position: absolute;
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: space-between;
  }
  .footer::after {
    content: "";
    height: 1px;
    position: absolute;
    top: 0;
    width: 100%;
    background-color: #e5e5e5;
    margin: 0 auto;
    padding: 0;
    overflow: hidden;
    transform: scaleY(0.5);
  }
  .cancel {
    width: 50%;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(54, 179, 116, 1);
    line-height: 47px;
    text-align: center;
  }
  .cancel::after {
    content: "";
    height: 100%;
    position: absolute;
    left: 50%;
    width: 1px;
    background-color: #e5e5e5;
    margin: 0 auto;
    padding: 0;
    overflow: hidden;
    transform: scaleX(0.5);
  }
  .close {
    width: 50%;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(54, 179, 116, 1);
    line-height: 47px;
    text-align: center;
  }
}
</style>
